import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { Button } from '@zurich/ui/legacy/components';
import { useAppInstance } from '../../hooks';
function AuthButton({ handleAuth, ...props }) {
    const [loading, setLoading] = useState(false);
    const handleClick = () => {
        if (!handleAuth) {
            console.error('No auth handler for authentication button!');
            return;
        }
        setLoading(true);
        handleAuth().catch(() => {
            setLoading(false);
        });
    };
    return (_jsx(Button, { variant: "contained", color: "primary", size: "large", loading: loading, onClick: handleClick, ...props }));
}
export function SignInButton({ label, ...props }) {
    const { t } = useTranslation();
    const { signIn } = useAppInstance();
    return (_jsx(AuthButton, { handleAuth: () => signIn(), ...props, children: label ?? t('nextapp:authButtons.signin.label') }));
}
export function RetrySignInButton({ label, ...props }) {
    const { t } = useTranslation();
    const { retrySignIn } = useAppInstance();
    return (_jsx(AuthButton, { handleAuth: () => retrySignIn(), ...props, children: label ?? t('nextapp:authButtons.retrySignin.label') }));
}
export function SignOutButton({ label, ...props }) {
    const { t } = useTranslation();
    const { signOut } = useAppInstance();
    return (_jsx(AuthButton, { handleAuth: () => signOut(), ...props, children: label ?? t('nextapp:authButtons.signout.label') }));
}
